import { Scoped } from '@visiba/instantiation';
import { Presentation } from '@visiba/presentation';
import { UnitsApiService } from '@src/api/units_api.service';
import { ComponentUnion, FlexibleComponentService } from '@services/flexible_component/flexible_component.service';
import { LocationSelectorService } from '@services/location_selector.service';
import type { GuiComponentApiModel } from '@api/generated/models';

interface Presentation {
	components: ComponentUnion[];
	textReceptionTitle: string;
	textReceptionBody: string;
	textAboutUs: string | null;
}

type FetchedTexts = 'View_Index_Body' | 'View_Index_Title' | 'Web_About';

@Scoped()
export class ReceptionHomeController {
	public readonly presentation = Presentation.createConcurrent<Presentation>();

	constructor(
		private readonly locationSelectorService: LocationSelectorService,
		private readonly unitsApiService: UnitsApiService,
		private readonly flexibleComponentService: FlexibleComponentService,
	) {
		// Empty
	}

	// TODO: DEV-9820 Research if we we should get rid of these types of methods.
	public onMount(): void {
		const textsPromise = this.unitsApiService.getTexts(this.locationSelectorService.locationUnitId, [
			'View_Index_Body',
			'View_Index_Title',
			'Web_About',
		]);
		const unitComponentsPromise = this.unitsApiService.getUnitComponents(this.locationSelectorService.locationUnitId);

		const promiseGroup = Promise.all([textsPromise, unitComponentsPromise]);
		this.presentation.suspend(promiseGroup, ([textsResponse, componentsResponse]) => {
			return this.parseResultsToPresentationModel([textsResponse.data, componentsResponse.data]);
		});
	}

	private parseResultsToPresentationModel([texts, componentsResponse]: readonly [
		Awaited<ReturnType<typeof this.unitsApiService.getTexts<FetchedTexts>>>['data'],
		GuiComponentApiModel[],
	]): Presentation {
		return {
			components: this.parseUnitComponentsResponse(componentsResponse),
			textReceptionTitle: texts.View_Index_Title ?? '',
			textReceptionBody: texts.View_Index_Body ?? '',
			textAboutUs: texts.Web_About,
		};
	}

	private parseUnitComponentsResponse(data: GuiComponentApiModel[]): ComponentUnion[] {
		const parsedComponents = data
			.sort((a, b) => {
				if (a.Order > b.Order) return 1;
				if (a.Order < b.Order) return -1;

				return 0;
			})
			.map((component) => {
				const type = component.Type === 'Button.Icon' ? 'ActionCard' : component.Type;

				return this.flexibleComponentService.produce(type, component) as ComponentUnion; // In backend we trust 🙏
			});

		return parsedComponents;
	}
}
